import OfferedProposal from './OfferedProposal';

export default OfferedProposal;
